import { Accordion, Card, Grid, InputText } from "#/atoms";
import { FC, memo } from "react";

import { DESKTOP_SPACING } from "@/theme";
import { OrderReferenceCardProps } from "./OrderReference.interface";

const OrderReferenceCard: FC<OrderReferenceCardProps> = ({
  accordionState = 'open',
  orderReference
}) => {
  return (
    <Card>
      <Accordion
        header={<strong>Please enter a reference for your new order</strong>}
        showArrow
        state={accordionState}
      >
        <Grid columnGap={DESKTOP_SPACING.XL} gridTemplateColumns="repeat(1, 40%)" margin="10px">
        <InputText
            type="text"
            label="Enter property address or job reference here"
            value={orderReference?.value}
            onChange={orderReference?.onChange}
          />
        </Grid>
      </Accordion>
    </Card>
  );
};

export default memo(OrderReferenceCard);